import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { editQuestionBankQuestion } from ".";

export function useEditBankQuestion() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.question_bank._def,
        mutationFn: editQuestionBankQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question_bank._def, exact: false });
        }
    });
}